import Component from 'inferno-component';
import PlayIcon from '../assets/images/play-deck-icon';
import DeleteIcon from '../assets/images/delete-deck-icon';
import ShareIcon from '../assets/images/share-icon';

class DisplayDeck extends Component {
  render() {
    const {
      deck,
      deleteWord,
      deleteSelectedDeck,
      playDeck,
      shareDeck,
      copiedDeck,
      setCopiedDeckOffset,
      editing,
      editDeck,
      makeEditable,
    } = this.props;
    const playDisabled = deck.cards.length === 0 ? true : false;
    const playButtonClass = playDisabled
      ? 'display-deck--play-button__disabled'
      : 'display-deck--play-button';
    return (
      <div
        ref={ref =>
          ref && copiedDeck && deck.deckId === copiedDeck.deckId
            ? setCopiedDeckOffset(ref.offsetTop)
            : null
        }
        className="flashcard--deck-card">
        <div className="flashcard--deck-card--top">
          <div
            className="flashcard--deck-card--title"
            onClick={() => makeEditable(deck.deckId)}>
            {editing ? (
              <form
                className="flashcard--deck-card--title-form"
                onSubmit={editDeck}>
                <input type="hidden" value={deck.deckId} name="id" />
                <input
                  ref={input => {
                    if (input) {
                      input.focus();
                      // reset value to place cursor at end of input
                      input.value = '';
                      input.value = deck.deckName;
                    }
                  }}
                  name="deckName"
                  type="text"
                  defaultValue={deck.deckName}
                  required={true}>{`${deck.deckName} (${
                  deck.cards.length
                })`}</input>
              </form>
            ) : (
              <h2>
                {deck.deckName}
                <span className="flashcard--deck-card--card-count">
                  {' '}
                  ({deck.cards.length})
                </span>
              </h2>
            )}
          </div>

          <div className="flashcard--deck-card--buttons">
            <form onSubmit={playDeck}>
              <input type="hidden" value={deck.deckId} name="id" />
              <button disabled={playDisabled} type="submit" className="button">
                <PlayIcon className={playButtonClass} />
              </button>
            </form>
            <form onSubmit={deleteSelectedDeck}>
              <input type="hidden" value={deck.deckId} name="id" />
              <button type="submit" className="button">
                <DeleteIcon />
              </button>
            </form>
          </div>
        </div>
        <hr />
        <h3>Words in this deck</h3>
        <div className="flashcard--deck-card--words-container">
          {deck.cards.length > 0 &&
            deck.cards.map(card => {
              return (
                <div className="flashcard--deck-card--item">
                  <span className="word">{card.word}</span>
                  <span className="delete">
                    <button
                      id={`delete-button${deck.deckId}-${card.word_id}`}
                      onClick={() => {
                        deleteWord(deck.deckId, card.word_id);
                      }}>
                      <span className="delete-x">x</span>
                    </button>
                  </span>
                </div>
              );
            })}
          {deck.cards.length === 0 && (
            <div>
              <div className="flashcard--deck-card--words-container--no-words">
                ʻAʻohe hua ʻōlelo ma kēia waihona kaleka<br /> You don't have
                any words in this deck yet
              </div>{' '}
              <div className="flashcard--deck-card--words-container--browse-words">
                <a href="/definition">
                  E ʻimi i nā hua ʻōlelo e hoʻohui ai i kēia waihona kaleka{' '}
                  <br />Browse for words to add &#187;
                </a>
              </div>
            </div>
          )}
        </div>
        <div className="flashcard--deck-card--words-container--share">
          <hr />
          <form onSubmit={shareDeck}>
            <input type="hidden" value={deck.deckId} name="id" />
            <button type="submit" className="button">
              <ShareIcon />
              <span>share this deck</span>
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default DisplayDeck;



// WEBPACK FOOTER //
// ./src/components/DisplayDeck.js